import React from 'react';
import Grid from 'material-ui/Grid';
import { Row } from 'react-flexbox-grid';
import { CircularProgress } from 'material-ui/Progress';
import Typography from '@material-ui/core/Typography';
import { convertEnergyInWhToBestUnit } from '../../../utils/unitHelper';

export class GreenElectricityCardContent extends React.Component {
  render() {
    const {
      classes,
      t,
      energyInWhForRange,
      energyInWhYTD,
      loading,
      dateRangeText,
    } = this.props;

    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    let totalEnergyMatched = energyInWhForRange;
    let totalEnergyMatchedYTD = energyInWhYTD;

    let [
      totalEnergyMatchedConverted,
      energyMatchedUnit,
    ] = convertEnergyInWhToBestUnit(totalEnergyMatched);
    let [
      totalEnergyMatchedYTDConverted,
      energyMatchedYTDUnit,
    ] = convertEnergyInWhToBestUnit(totalEnergyMatchedYTD);

    return (
      <div>
        <Grid container spacing={24}>
          <Grid item>
            <Row>
              <Typography
                className={classes.title}
                variant="caption"
                gutterBottom
                color="textSecondary"
              >
                {dateRangeText}
              </Typography>
            </Row>
            <Row>
              <Typography
                variant="h5"
                gutterBottom
                style={{ color: '#F87733' }}
              >
                {' '}
                {totalEnergyMatchedConverted}{' '}
                <span style={{ fontSize: '0.75rem' }}>{energyMatchedUnit}</span>
              </Typography>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Typography
                className={classes.title}
                variant="caption"
                gutterBottom
                color="textSecondary"
              >
                {t('Yearly')}
              </Typography>
            </Row>
            <Row>
              <Typography
                variant="h5"
                gutterBottom
                style={{ color: '#F87733' }}
              >
                {' '}
                {totalEnergyMatchedYTDConverted}{' '}
                <span style={{ fontSize: '0.75rem' }}>
                  {energyMatchedYTDUnit}
                </span>
              </Typography>
            </Row>
          </Grid>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/GreenElectricity/GreenElectricityCardContent.js